import React from "react";



import AboutUSs from "./../../images/resources/aboutus.png";

import main from "./../../images/resources/main.png";

import lafuerza from "./../../images/resources/lafuerza.png";

import international from "./../../images/resources/international.png";



const shortcuts = [

  { label: "Vision", id: "vision" },

  { label: "Mission", id: "mission" },

  { label: "Our Spaces", id: "spaces" },



  { label: "Auction Highlights", id: "auction-highlights" },

];



const SectionHeading = ({ eyebrow, title, id }) => (

  <div id={id} style={{ marginBottom: 34, scrollMarginTop: 110 }}>

    {eyebrow && (

      <div

        style={{

          fontSize: 11,

          letterSpacing: "0.22em",

          textTransform: "uppercase",

          color: "#777",

          marginBottom: 12,

        }}

      >

        {eyebrow}

      </div>

    )}

    <h2

      style={{

        margin: 0,

        fontFamily: 'Georgia, "Times New Roman", serif',

        fontSize: "clamp(30px, 4vw, 52px)",

        lineHeight: 1.05,

        fontWeight: 400,

        letterSpacing: "-0.025em",

        color: "#111",

      }}

    >

      {title}

    </h2>

  </div>

);



const SpaceCard = ({ title, image, children, reverse }) => (

  <article

    style={{

      display: "grid",

      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",

      minHeight: 470,

      borderTop: "1px solid #d8d8d8",

    }}

  >

    <div

      style={{

        order: reverse ? 2 : 1,

        minHeight: 420,

        background: "#f3f2ef",

        overflow: "hidden",

      }}

    >

      <img

        src={image}

        alt={title}

        style={{

          width: "100%",

          height: "100%",

          minHeight: 420,

          objectFit: "cover",

          display: "block",

        }}

      />

    </div>



    <div

      style={{

        order: reverse ? 1 : 2,

        padding: "clamp(36px, 6vw, 90px)",

        display: "flex",

        flexDirection: "column",

        justifyContent: "center",

        background: "#fff",

      }}

    >

      <div

        style={{

          fontSize: 11,

          letterSpacing: "0.2em",

          textTransform: "uppercase",

          color: "#777",

          marginBottom: 16,

        }}

      >

        León Gallery

      </div>

      <h3

        style={{

          margin: "0 0 22px",

          fontFamily: 'Georgia, "Times New Roman", serif',

          fontSize: "clamp(28px, 3vw, 42px)",

          fontWeight: 400,

          lineHeight: 1.1,

        }}

      >

        {title}

      </h3>

      <div

        style={{

          color: "#444",

          fontSize: 15,

          lineHeight: 1.85,

          maxWidth: 610,

        }}

      >

        {children}

      </div>

    </div>

  </article>

);



const About = () => {

  const scrollTo = (id) => {

    const element = document.getElementById(id);

    if (element) element.scrollIntoView({ behavior: "smooth", block: "start" });

  };



  return (

    <div style={{ background: "#fff", color: "#111" }}>

      <style>{`
        .about-page * { box-sizing: border-box; }
        .about-page a { color: inherit; text-decoration: none; }
        .about-page .about-shortcut:hover { background: #111 !important; color: #fff !important; }
        .about-page .about-link:hover { opacity: .55; }

        /* HERO */
        .about-page .hero-inner {
          width: 100%;
        }

        .about-page .hero-copy {
          display: block;
          width: min(760px, 62vw);
          max-width: 760px;
          padding: 52px 56px 48px;
          background: rgba(0, 0, 0, .78);
          color: #fff;
        }

        .about-page .hero-copy h1,
        .about-page .hero-copy .hero-eyebrow,
        .about-page .hero-copy .hero-description {
          color: #fff;
        }

        /* TABLET */
        @media (max-width: 1199px) {
          .about-page .space-grid article {
            grid-template-columns: 1fr !important;
            min-height: 0 !important;
          }

          .about-page .space-grid article > div {
            order: initial !important;
          }

          .about-page .space-grid article > div:first-child {
            min-height: 0 !important;
          }

          .about-page .space-grid article img {
            width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            aspect-ratio: 16 / 10;
            object-fit: cover !important;
          }
        }

        /* MOBILE */
        @media (max-width: 800px) {
          .about-page .hero-inner {
            padding: 34px 16px 30px !important;
          }

          .about-page .hero-copy {
            width: 100% !important;
            max-width: none !important;
            padding: 26px 22px 28px !important;
            background: rgba(0, 0, 0, .80) !important;
          }

          .about-page .hero-copy h1 {
            font-size: clamp(42px, 13vw, 68px) !important;
            line-height: .95 !important;
            letter-spacing: -.04em !important;
          }

          .about-page .hero-copy .hero-eyebrow {
            font-size: 10px !important;
            line-height: 1.5 !important;
            letter-spacing: .16em !important;
            margin-bottom: 16px !important;
          }

          .about-page .hero-copy .hero-description {
            margin-top: 20px !important;
            font-size: 15px !important;
            line-height: 1.6 !important;
          }

          .about-page .shortcut-row {
            overflow-x: auto;
            justify-content: flex-start !important;
            flex-wrap: nowrap !important;
            scrollbar-width: none;
          }

          .about-page .shortcut-row::-webkit-scrollbar {
            display: none;
          }

          .about-page .shortcut-row button {
            flex: 0 0 auto;
          }

          .about-page .intro-grid {
            grid-template-columns: 1fr !important;
            gap: 38px !important;
          }

          .about-page .space-grid article {
            display: grid !important;
            grid-template-columns: 1fr !important;
            min-height: 0 !important;
          }

          .about-page .space-grid article > div {
            order: initial !important;
            min-height: 0 !important;
          }

          .about-page .space-grid article img {
            width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            aspect-ratio: 16 / 10;
            object-fit: cover !important;
          }

          .about-page .space-grid article > div:nth-child(2) {
            padding: 34px 22px !important;
          }

          .about-page .space-grid article h3 {
            font-size: 32px !important;
          }

          .about-page .space-grid article p {
            font-size: 15px !important;
            line-height: 1.75 !important;
          }

          .about-page .stat-grid {
            grid-template-columns: 1fr 1fr !important;
          }

          .about-page .stat-grid > div {
            border-right: 0 !important;
            border-bottom: 1px solid #ddd;
          }

          .about-page .stat-grid > div:last-child {
            border-bottom: 0;
          }

          .about-page section {
            scroll-margin-top: 90px;
          }
        }

        @media (max-width: 520px) {
          .about-page .hero-inner {
            padding: 24px 12px 24px !important;
          }

          .about-page .hero-copy {
            padding: 22px 18px 24px !important;
          }

          .about-page .hero-copy h1 {
            font-size: 46px !important;
          }

          .about-page .hero-copy .hero-description {
            font-size: 14px !important;
          }

          .about-page .stat-grid {
            grid-template-columns: 1fr !important;
          }

          .about-page .stat-grid > div {
            border-bottom: 1px solid #ddd;
          }

          .about-page .stat-grid > div:last-child {
            border-bottom: 0;
          }
        }
      `}</style>



      <div className="about-page">

        {/* Editorial hero */}

        <section

          style={{

            position: "relative",

            minHeight: "min(690px, 78vh)",

            display: "flex",

            alignItems: "flex-end",

            background: `linear-gradient(rgba(0,0,0,.12), rgba(0,0,0,.48)), url(${AboutUSs}) center / cover no-repeat`,

          }}

        >

          <div

            className="hero-inner"

            style={{

              width: "100%",

              padding: "110px 7vw 80px",

              color: "#fff",

            }}

          >

            <div className="hero-copy">

            <div

              className="hero-eyebrow"

              style={{

                fontSize: 11,

                letterSpacing: "0.28em",

                textTransform: "uppercase",

                marginBottom: 20,

                opacity: 0.9,

              }}

            >

              Fine Art · Exhibitions · Private Sales

            </div>

            <h1

              style={{

                margin: 0,

                fontFamily: 'Georgia, "Times New Roman", serif',

                fontWeight: 400,

                fontSize: "clamp(52px, 8vw, 112px)",

                lineHeight: 0.92,

                letterSpacing: "-0.045em",

              }}

            >

              About León

            </h1>

            <div

              className="hero-description"

              style={{

                marginTop: 28,

                maxWidth: 620,

                fontSize: "clamp(15px, 1.5vw, 20px)",

                lineHeight: 1.65,

              }}

            >

              A gallery and auction house dedicated to Philippine art,

              heritage and collecting.

            </div>

            </div>

          </div>

        </section>



        {/* Quick access */}

        <nav

          aria-label="About page shortcuts"

          style={{

            position: "sticky",

            top: 0,

            zIndex: 20,

            background: "rgba(255,255,255,.96)",

            backdropFilter: "blur(12px)",

            borderBottom: "1px solid #dedede",

            borderTop: "1px solid #dedede",

          }}

        >

          <div

            className="shortcut-row"

            style={{

              maxWidth: 1380,

              margin: "0 auto",

              padding: "0 22px",

              minHeight: 58,

              display: "flex",

              alignItems: "center",

              justifyContent: "center",

              gap: 0,

            }}

          >

            {shortcuts.map((item, index) => (

              <React.Fragment key={item.id}>

                {index > 0 && (

                  <span style={{ color: "#bbb", margin: "0 4px" }}>·</span>

                )}

                <button

                  type="button"

                  className="about-shortcut"

                  onClick={() => scrollTo(item.id)}

                  style={{

                    border: 0,

                    background: "transparent",

                    padding: "10px 14px",

                    cursor: "pointer",

                    fontSize: 11,

                    letterSpacing: "0.14em",

                    textTransform: "uppercase",

                    color: "#222",

                    transition: "all .2s ease",

                    whiteSpace: "nowrap",

                  }}

                >

                  {item.label}

                </button>

              </React.Fragment>

            ))}

          </div>

        </nav>



        {/* Intro / vision / mission */}

        <section style={{ maxWidth: 1380, margin: "0 auto", padding: "110px 22px 90px" }}>

          <div

            className="intro-grid"

            style={{

              display: "grid",

              gridTemplateColumns: "0.8fr 1.2fr",

              gap: "clamp(50px, 9vw, 150px)",

              alignItems: "start",

            }}

          >

            <div>

              <div

                style={{

                  fontSize: 11,

                  letterSpacing: "0.2em",

                  textTransform: "uppercase",

                  color: "#777",

                  marginBottom: 18,

                }}

              >

                Our story

              </div>

              <h2

                style={{

                  margin: 0,

                  fontFamily: 'Georgia, "Times New Roman", serif',

                  fontSize: "clamp(38px, 5vw, 70px)",

                  lineHeight: 1,

                  fontWeight: 400,

                  letterSpacing: "-0.04em",

                }}

              >

                Art, history

                <br />

                &amp; culture.

              </h2>

            </div>



            <div style={{ maxWidth: 760 }}>

              <p style={{ margin: 0, fontSize: 20, lineHeight: 1.75, color: "#333" }}>

                León Gallery is dedicated to making important Philippine art and

                heritage accessible through auctions, exhibitions, private sales

                and thoughtful collecting.

              </p>

              <div style={{ height: 1, background: "#d8d8d8", margin: "42px 0" }} />

              <p style={{ margin: 0, fontSize: 15, lineHeight: 1.9, color: "#555" }}>

                Since 2010, the gallery has specialized in important Philippine

                art, Old Masters, modernist works, contemporary art and

                historically significant antiques and heirloom objects.

              </p>

            </div>

          </div>

        </section>



        <section style={{ background: "#f5f4f1", padding: "95px 22px" }}>

          <div style={{ maxWidth: 1380, margin: "0 auto" }}>

            <div className="intro-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "clamp(45px, 8vw, 130px)" }}>

              <div id="vision" style={{ scrollMarginTop: 110 }}>

                <SectionHeading eyebrow="01" title="Our Vision" />

                <p style={{ margin: 0, fontSize: 16, lineHeight: 1.9, color: "#4b4b4b" }}>

                  Art is an important foundation of Filipino history and culture.

                  It has the power to move, encourage and above all, inspire. We

                  believe in a society surrounded by the power of art to constantly

                  engage in conversation with ourselves, others and society at large.

                  We therefore believe in art education, the cultivation of its

                  appreciation, and through it, our country’s growth and development.

                </p>

              </div>



              <div id="mission" style={{ scrollMarginTop: 110 }}>

                <SectionHeading eyebrow="02" title="Our Mission" />

                <p style={{ margin: 0, fontSize: 16, lineHeight: 1.9, color: "#4b4b4b" }}>

                  Our mission is to make the best of Filipino art accessible to the

                  world. Our experts work across authentication, documentation,

                  preservation, pricing and bidding so collectors can navigate the

                  process with confidence.

                </p>

                <p style={{ margin: "22px 0 0", fontSize: 16, lineHeight: 1.9, color: "#4b4b4b" }}>

                  Our collections encompass Old Masters, modernist works,

                  contemporary artists and Philippine antiques, as well as culturally

                  significant furniture, ivory, silver, porcelain, rugs, jewelry,

                  rare books, maps and historical objects.

                </p>

              </div>

            </div>

          </div>

        </section>



        {/* Spaces */}

        <section id="spaces" style={{ paddingTop: 100, scrollMarginTop: 110 }}>

          <div style={{ maxWidth: 1380, margin: "0 auto", padding: "0 22px 50px" }}>

            <SectionHeading eyebrow="03 · Our Spaces" title="The Gallery & Auction House" />

          </div>



          <div className="space-grid">

            <SpaceCard title="León Gallery Main" image={main}>

              <p style={{ margin: "0 0 18px" }}>

                León Gallery, established in 2010, quickly became known for its

                focus on high-quality Philippine art with historical significance.

              </p>

              <p style={{ margin: 0 }}>

                The gallery's expertise lies in the works of Filipino Old Masters,

                the Thirteen Moderns and leading figures in Philippine modern and

                contemporary art. León Gallery also exhibits the creations of

                National Artists for Visual Arts and Sculpture and noteworthy

                contemporary artists.

              </p>

            </SpaceCard>



            <SpaceCard title="Lafuerza" image={lafuerza} reverse>

              <p style={{ margin: 0 }}>

                LeonExchange serves as your digital portal to discover your next

                treasure. Conducted quarterly, it acts as a curated hub for vintage,

                high-quality and previously cherished items sourced from distinguished

                collections and esteemed estates.

              </p>

            </SpaceCard>



            <SpaceCard title="León Gallery International" image={international}>

              <p style={{ margin: 0 }}>

                Situated in the heart of Makati City, the country’s financial district,

                León Gallery International is León Gallery’s premier exhibition space.

                Since its inception, the space has been the site of groundbreaking

                exhibitions featuring Filipino and international artists.

              </p>

            </SpaceCard>

          </div>

        </section>





        {/* Auction highlights */}

        <section id="auction-highlights" style={{ padding: "110px 22px 120px", scrollMarginTop: 110 }}>

          <div style={{ maxWidth: 1380, margin: "0 auto" }}>

            <SectionHeading eyebrow="05 · Auction Highlights" title="The auction house" />

            <div style={{ maxWidth: 900, fontSize: 17, lineHeight: 1.9, color: "#4b4b4b" }}>

              <p style={{ marginTop: 0 }}>

                León Gallery is known for its regular auctions featuring Filipino

                Old Masters, modern and contemporary artists, and historically

                important works. Since its first auction in 2013, the gallery has

                continued to build a strong auction program around Philippine art

                and culture.

              </p>

              <p>

                Collectors may participate through live auctions, phone bidding,

                online bidding or absentee bidding. The gallery also regularly

                organizes previews and exhibitions alongside its auction program.

              </p>

            </div>



            <div className="stat-grid" style={{ marginTop: 70, display: "grid", gridTemplateColumns: "repeat(3, 1fr)", borderTop: "1px solid #222", borderBottom: "1px solid #222" }}>

              <div style={{ padding: "34px 24px", borderRight: "1px solid #ddd" }}>

                <div style={{ fontFamily: 'Georgia, "Times New Roman", serif', fontSize: 44 }}>2010</div>

                <div style={{ marginTop: 8, fontSize: 11, letterSpacing: "0.16em", textTransform: "uppercase", color: "#777" }}>Established</div>

              </div>

              <div style={{ padding: "34px 24px", borderRight: "1px solid #ddd" }}>

                <div style={{ fontFamily: 'Georgia, "Times New Roman", serif', fontSize: 44 }}>2013</div>

                <div style={{ marginTop: 8, fontSize: 11, letterSpacing: "0.16em", textTransform: "uppercase", color: "#777" }}>First auction</div>

              </div>

              <div style={{ padding: "34px 24px" }}>

                <div style={{ fontFamily: 'Georgia, "Times New Roman", serif', fontSize: 44 }}>PH</div>

                <div style={{ marginTop: 8, fontSize: 11, letterSpacing: "0.16em", textTransform: "uppercase", color: "#777" }}>Philippine art & heritage</div>

              </div>

            </div>

          </div>

        </section>



        <footer style={{ borderTop: "1px solid #ddd", padding: "30px 22px", color: "#777", fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase" }}>

          <div style={{ maxWidth: 1380, margin: "0 auto", display: "flex", justifyContent: "space-between", gap: 20, flexWrap: "wrap" }}>

            <span>León Gallery</span>

            <button type="button" className="about-link" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} style={{ border: 0, background: "none", padding: 0, cursor: "pointer", color: "inherit", fontSize: "inherit", letterSpacing: "inherit", textTransform: "inherit" }}>

              Back to top ↑

            </button>

          </div>

        </footer>

      </div>

    </div>

  );

};



export default About;
